import { heidi2OnboardingMessages } from './heidi2Onboarding.messages';

export type Heidi2BookMeetingStep = 'time' | 'details' | 'confirmed';

/**
 * The title and subtitle the dialog shell shows for each scheduler step.
 *
 * `hidden` on the confirmation step: that screen centres its own heading in
 * the body, so the header stays only to give the dialog its accessible name.
 * The title has to live in the shell either way — `DialogTitle` needs the
 * dialog's own context, which the lazily loaded body is not guaranteed.
 *
 * Kept out of `Heidi2BookMeetingContent` so the always-mounted shell can title
 * the dialog without pulling the lazy chunk in behind it.
 */
export const heidi2BookMeetingHeading = (step: Heidi2BookMeetingStep) => {
  if (step === 'confirmed') {
    return {
      title: heidi2OnboardingMessages.bookMeetingConfirmedTitle,
      subtitle: heidi2OnboardingMessages.bookMeetingConfirmedSubtitle,
      hidden: true,
    };
  }
  return step === 'time'
    ? {
        title: heidi2OnboardingMessages.bookMeetingTitle,
        subtitle: heidi2OnboardingMessages.bookMeetingSubtitle,
        hidden: false,
      }
    : {
        title: heidi2OnboardingMessages.bookMeetingDetailsTitle,
        subtitle: heidi2OnboardingMessages.bookMeetingDetailsSubtitle,
        hidden: false,
      };
};
